import { Divider, Grid } from "@mui/material";

import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import TimelineList from "ui-components/Timeline/TimelineList";
import TimelineItem from "ui-components/Timeline/TimelineItem";
import { getPOLog } from "services/data.inbound.service";
import Drawer from "ui-components/Drawer";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";

const columns = [
  { label: "SKU Code", id: "skuCode" },
  { label: "Qty Ordered", id: "qtyOrdered" },
  { label: "Qty Received", id: "qtyReceived" },
  { label: "Status", id: "status" },
];

function POLog({ open, setOpen, logRequest, setLogRequest }) {
  const getStatus = (status) => {
    if (status === "O") {
      return <MDBadge variant="gradient" color="info" size="xs" badgeContent="Open" container />;
    } else if (status === "R") {
      return (
        <MDBadge variant="gradient" color="success" size="xs" badgeContent="Received" container />
      );
    } else if (status === "C") {
      return (
        <MDBadge variant="gradient" color="warning" size="xs" badgeContent="Cancelled" container />
      );
    }else if (status === "F") {
      return (
        <MDBadge variant="gradient" color="primary" size="xs" badgeContent="Closed" container />
      );
    }
  };

  const { data } = useQuery({
    queryKey: ["po-log", { logRequest }],
    queryFn: () => getPOLog(logRequest),
    enabled: Boolean(logRequest),
  });
  const details = data?.data.data.details.map((d) => ({
    ...d,
    status: getStatus(d.status),
  }));

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogRequest(null);
  };

  return (
    <Drawer open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      <MDTypography variant="h5" color="info">
        Purchase Order
      </MDTypography>
      <Divider sx={{ margin: "5px 0", background: "#9ebeeb", opacity: "unset" }} />
      {Boolean(data) && (
        <>
          <MDBox style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={6}>
                <b>PO Number : </b>
                {data.data.data.poNumber}
              </Grid>
              <Grid item xs={6}>
                <b>PO Date : </b>
                {data.data.data.poDate}
              </Grid>
            </Grid>
          </MDBox>
          <StickyHeadTable columns={columns} rows={details} />
          <TimelineList title="Logs">
            {data.data.data.logs.map(({ id, ...log }) => (
              <TimelineItem key={id} {...log} />
            ))}
          </TimelineList>
        </>
      )} 
    </Drawer>
  );
}

export default POLog;
